import React, { useContext } from 'react';
export const defaultValue = {
    showArrow: false,
    animation: 'scale',
    outsideCloseable: true,
};
export const TooltipContext = React.createContext(defaultValue);
export const useTooltip = () => useContext(TooltipContext);
